import { render, staticRenderFns } from "./WorkOrderWrapper.vue?vue&type=template&id=6ffbcfee"
import script from "./WorkOrderWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkOrderWrapper.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports